module.exports = __webpack_public_path__ + "img/testimonials-bgr.cf5edd25.svg";